export default __webpack_public_path__ + "static/media/wizard.362b1522.png";